import { BaseContainerModel } from '../../../base-container.model';
import {bl_del_logistic_provider_hdr_RowClass} from '../../../../dbschema';

export class DelLogisticProviderHdrContainerModel extends BaseContainerModel {
    bl_del_logistic_provider_hdr: bl_del_logistic_provider_hdr_RowClass = new bl_del_logistic_provider_hdr_RowClass();
}
